import React from "react";
import isEmpty from "lodash/isEmpty";
export var useEditEmployee = function () {
    var _a = React.useState(""), name = _a[0], setName = _a[1];
    var _b = React.useState(""), password = _b[0], setPassword = _b[1];
    var _c = React.useState({}), errors = _c[0], setErrors = _c[1];
    var validate = function () {
        var validated = {};
        if (name.length === 0) {
            validated.name = "Заполните поле.";
        }
        if (password.length < 8) {
            validated.password = "Минимальная длина пароля - 8 символов.";
        }
        setErrors(validated);
        return isEmpty(validated);
    };
    return {
        validate: validate,
        name: { value: name, set: setName, error: errors.name },
        password: { value: password, set: setPassword, error: errors.password },
    };
};
